// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#map[data-v-50d738ae]{height:600px;@media (max-width:960px){height:400px}}.drivers-list[data-v-50d738ae]{max-height:800px;overflow-y:auto;@media (max-width:960px){max-height:250px}}.driver-label[data-v-50d738ae]{text-align:center}", ""]);
// Exports
module.exports = exports;
